import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Layout() {
  return (
    <div className="flex flex-col min-screen">
      <div className="flex-grow">
        <Outlet style={{ flex: 1 }}/>
      </div>
      <Footer/>
    </div>
  );
}

export default Layout;
